<div class="slidecontainer">
  <label for="slider">{{ label }} ({{ value }})</label>
  <input id="slider" type="range" [min]="min" [max]="max" [(ngModel)]="value" (change)="updateValue($event)" />
</div>
